function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'sensitive-zitronengelb': 'rgb(241, 221, 56)','sensitive-lemon-yellow': 'rgb(241, 221, 56)','sensitive-weiss': 'rgb(241, 236, 225)','sensitive-white': 'rgb(241, 236, 225)','regular-orange': 'rgb(218, 110, 0)','regular-brombeer': 'rgb(101, 30, 56)','regular-bramble': 'rgb(101, 30, 56)','active-signalblau': 'rgb(0, 159, 227)','active-signal-blue': 'rgb(0, 159, 227)','active-pink': 'rgb(230, 0, 126)','intense-rubinrot': 'rgb(187, 30, 16)','intense-ruby-red': 'rgb(187, 30, 16)','intense-nachtblau': 'rgb(26, 43, 60)','intense-night-blue': 'rgb(26, 43, 60)','pink': 'rgb(230, 0, 126)','signalblau': 'rgb(0, 159, 227)','grau': 'rgb(206, 204, 205)','rosa': 'rgb(171, 88, 138)','turkis': 'rgb(7, 178, 216)',};

    this.images = {'weiss-brombeer-nachtblau': 'url("//www.bellabambi.de/cdn/shop/files/wbn_68x.png?v=4991396550507042368")','zitronengelb-orange-rubinrot': 'url("//www.bellabambi.de/cdn/shop/files/zor_68x.png?v=14859645793778420899")','white-bramble-night-blue': 'url("//www.bellabambi.de/cdn/shop/files/wbn_68x.png?v=4991396550507042368")','lemon-yellow-orange-ruby-red': 'url("//www.bellabambi.de/cdn/shop/files/zor_68x.png?v=14859645793778420899")',};

    this.triggers = ['color','colour','couleur','farbe','cor','intensität-farbe','intensity-color','intensity-colour',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
